module.exports = __webpack_public_path__ + "img/tool3.f3b9153.png";